import React from "react";
import { hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hidratamos el HTML prerenderizado en vez de re-renderizar desde cero
// (createRoot). Así el contenido prerenderizado (incl. la imagen/texto del hero
// = elemento LCP) NO se descarta, y el LCP baja drásticamente.
hydrateRoot(
  document.getElementById("root"),
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
